
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Carousel, CarouselItem } from 'element-ui'
import { BannerManageImpl } from '@/commons/bannerManage'
import { BannerService } from '@/commons/bannerService'
import PosterImage from '@/components/poster-image.vue'
// import News3 from '@/pages/index/components/News3.vue'
import News4 from '@/pages/index/components/News4.vue'
import instance from '@/service'
Vue.use(Carousel)
Vue.use(CarouselItem)

@Component({
  components: {
    PosterImage,
    // News3,
    News4
  }
})
export default class extends Vue {
  private manager = new BannerManageImpl(new BannerService())
  private pid = 0
  // private nestitle!: []
  async mounted () {
    this.manager.requestBannerList()
    // this.manager.getNewstitles()
    this.manager.getProjectSystemInfor()
  }

  @Prop()
  private menus!: Array<any>

  get asyncMenus () {
    if (!this.menus || this.menus.length === 0) {
      return []
    }
    return this.menus.filter((item: any, index: number) => ['政策法规', '行业动态', '通知公告', '培训通知'].includes(item.title))
  }

  private activeMenuIndex = 0

  toggleHandler (index: number) {
    this.activeMenuIndex = index
  }

  get currentMenu () {
    console.log(this.asyncMenus)
    return this.asyncMenus.find((item: any, index: number) => index === this.activeMenuIndex)
  }

  private goLinkpage (url: string) {
    if (!url) { return }
    if (!url.includes('http://') && !url.includes('https://')) {
      url = 'https://' + url
    }
    window.open(url)
  }

  directProjcts (project: any, preId?: string) {
    const projectIds = []
    projectIds.push(project.projectSystemId)
    if (preId) {
      projectIds.push(preId)
    }
    localStorage.setItem('selectedChapter', JSON.stringify(projectIds))
    window.location.href = `/study.html#/?id=${project.projectSystemId}`
  }
}
